import { render, staticRenderFns } from "./MessagebirdNumberMasking.vue?vue&type=template&id=3c51134f&"
import script from "./MessagebirdNumberMasking.vue?vue&type=script&lang=js&"
export * from "./MessagebirdNumberMasking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports